import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as LinkIcon } from 'assets/icons/link.svg';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidUrl, withProtocol } from 'utils/url';

interface ToggleProps {
  isActive: boolean;
  value?: string;
  // Null is when the alert is dismissed by clicking outside
  // Or when an invalid url is entered
  onChange: (url: string | null) => void;
  onMouseDown?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const AddLinkButton = ({ value, isActive, onChange, onMouseDown }: ToggleProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'hyperLink' });
  const label = t('label');

  const onChangeLink = () => {
    const newUrl = window.prompt('URL', value);

    if (newUrl === null) return onChange(null);
    if (newUrl === '') return onChange(newUrl);

    const fullUrl = withProtocol(newUrl);
    // When a link is added to an image - set isDecorative to false so that it will be read by screen readers
    if (isValidUrl(fullUrl)) return onChange(fullUrl);

    // invalid url
    return onChange(null);
  };

  return (
    <Tooltip hasArrow placement='bottom' label={label} bg='black'>
      <IconButton
        isActive={isActive}
        onClick={onChangeLink}
        onMouseDown={onMouseDown}
        size='sm'
        aria-label={label}
        variant='icon-btn-toolbar'
        icon={<LinkIcon />}
      />
    </Tooltip>
  );
};
AddLinkButton.displayName = 'Link';
